/**
 * @generated SignedSource<<2449ec8dba37779e1c5e9e36583e2bbb>>
 * @relayHash d1beaa948706042f4c92ffe38dba012b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c9a4619880e3c3efd50ad338b8a09ff2e30f504ebe1b7ae16fbc6c51deabebd4

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useContextualEmojiUserPreferencesQuery$variables = Record<PropertyKey, never>;
export type useContextualEmojiUserPreferencesQuery$data = {
  readonly userPreferences: {
    readonly contextualEmojiOptOut: boolean | null | undefined;
  } | null | undefined;
};
export type useContextualEmojiUserPreferencesQuery = {
  response: useContextualEmojiUserPreferencesQuery$data;
  variables: useContextualEmojiUserPreferencesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contextualEmojiOptOut"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContextualEmojiUserPreferencesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useContextualEmojiUserPreferencesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d1beaa948706042f4c92ffe38dba012b",
    "id": "c9a4619880e3c3efd50ad338b8a09ff2e30f504ebe1b7ae16fbc6c51deabebd4",
    "metadata": {},
    "name": "useContextualEmojiUserPreferencesQuery",
    "operationKind": "query",
    "text": "query useContextualEmojiUserPreferencesQuery{userPreferences{contextualEmojiOptOut}}"
  }
};
})();

(node as any).hash = "bc9a4c9849d6d778b5ea743a2a5c52ab";

export default node;
